export const getAlbumItemsState = (state, action) => {
	return state.collectionId === action.collectionId ?
		new Map([...state.albumItems.entries(), ...getMapFromIdObjectArray(action.albumItems)]) :
		getMapFromIdObjectArray(action.albumItems);
};



export const getAlbumItemsSliderState = (state, action) => {
	const theReturn = state.collectionId === action.collectionId ?
		new Map([...state.itemSlider.entries(), ...getMapFromDisplayOrderObjectArray(action.albumItems)]) :
		getMapFromDisplayOrderObjectArray(action.albumItems);


	var mapAsc = new Map([...theReturn.entries()].sort((a, b) => {
		return a[0] - b[0];
	}));
	return mapAsc;
};


export const addSelected = (array, id, isSelected) => {
	return array.map((item) => {
		if (item.id !== id) {

			return item;
		}
		item.selected = isSelected;
		// Otherwise, this is the one we want - return an updated value
		return item;
	});
};

export const clearAllSelections = (array) => {
	return array.map((item) => {

		item.selected = false;
		// Otherwise, this is the one we want - return an updated value
		return item;
	});
};

export const removeItem = (array, index) => {
	return [
		...array.slice(0, index),
		...array.slice(index + 1)
	];
};

export const removeAssetFromArray = (array, asset) => {
	const index = array.indexOf(asset);
	return [
		...array.slice(0, index),
		...array.slice(index + 1)
	];
};

export const addAssetToArrayIfNew = (array, asset) => {
	const index = array.indexOf(asset);
	if(index > 0){
	return [
		...array
	];
}
else
return [...array, asset];
};

export const updateObjectInArray = (array, updatedItem, mergeIndex) => {
	return array.map((item, index) => {
		if (index !== mergeIndex) {
			// This isn't the item we care about - keep it as-is
			return item;
		}

		// Otherwise, this is the one we want - return an updated value
		return {
			...item,
			...updatedItem
		};
	});
};

export const updateObjectInArrayById = (array, updatedItem, id) => {

	return array.map((item) => {
		if (item.id !== id) {
			return item;
		}


		return {
			...item,
			...updatedItem
		};
	});
};



export const setIdObjectSelectionInNewMap = (map, id, isPartial, overrideSelected) => {
	let tempItem = map.get(id);
	if (typeof (overrideSelected) !== "undefined") {
		tempItem.selected = overrideSelected === true;
	} else {
		tempItem.selected = !tempItem.selected;
	}
	if (isPartial === true) {
		tempItem.partialSelected = true;
	} else {
		tempItem.partialSelected = false;
	}
	let returnMap = new Map([...map]);
	returnMap.set(id, tempItem);
	return returnMap;
};

export const getMapFromIdObjectArray = arr => {
	let returnMap = new Map();
	arr.forEach(item => {
		returnMap.set(parseInt(item.id, 10), item);
	});
	return returnMap;
};

export const getMapFromDisplayOrderObjectArray = arr => {
	let returnMap = new Map();
	arr.forEach(item => {
		returnMap.set(parseInt(item.displayOrder, 10), item);
	});
	return returnMap;
};
export const addOptionsIfNew = (previousOptions, newOptions, reverse = true) => {
	var theNewOptions = newOptions;
	if (reverse) {
		theNewOptions = newOptions.slice().reverse();
	}


	const allOptions = [...previousOptions, ...theNewOptions.map(album => {
		return (

			{
				key: album.id,
				label: album.title
			}
		);
	})];


	return allOptions.filter((arr, index, self) => index === self.findIndex(t => t.key === arr.key && t.label === arr.label));

};

export const addOptionIfNew = (previousOptions, newOptions) => {

	const allOptions = [{
    key: newOptions.id,
    label: newOptions.title
  }, ...previousOptions];


	return allOptions.filter((arr, index, self) => index === self.findIndex(t => t.key === arr.key && t.label === arr.label));

};

export const removeObjectFromArray = (selectionArray, objectId) => {
	return selectionArray.filter(t => t.key != objectId);
};
export const removeItemFromSetAndCreateNew = (inputSet, item) => {
	inputSet.delete(item);
	item = null;
	return new Set([...inputSet]);
};
export const replaceObjectInArray = (myArray, theObject) => {
	var theFile = theObject.file;
	theFile.progressPercent = theObject.progress;
	theFile.progress = theObject.progress;


	theFile.progressStats = {
		loaded: theObject.loaded,
		total: theObject.total
	};
	if (theFile.progress === "undefined") {
		//	theFile.progress = 100;
	}


	theFile.waiting = false;
	const index = myArray.findIndex(item => item.name + item.size === theFile.name + theFile.size);
	if (index === -1) {
		return [...myArray];
	} else {


		return [
			...myArray.slice(0, index),
			theFile,
			...myArray.slice(index + 1)
		];
	}

};
export const removeObjectInArray = (myArray, theObject) => {
	var theFile = theObject.file;
	const index = myArray.findIndex(item => item.name + item.size === theFile.name + theFile.size);
	if (index === -1) {
		return [...myArray];
	} else {

		theFile.progress = theObject.progress;
		return [
			...myArray.slice(0, index),
			...myArray.slice(index + 1)
		];
	}

};
export const addToArrayIfNewObject = (myArray, theObject) => {

	const file = theObject.file;
	file.waiting = true;
	file.progress = 0;

	const index = myArray.findIndex(item => item.name + item.size === file.name + file.size);
	if (index === -1) {
		return [...myArray, file];
	} else {
		return [...myArray];
	}
};


export const removeItemFromSetAndCreateNewWithId = (inputSet, picture) => {

	const selectArray = Array.from(inputSet);
	const index = selectArray.findIndex(item => item.id === picture.id);
	const newArray = removeItem(selectArray, index);
	return new Set([...newArray]);
};

export const addIdObjectToNewMap = (map, item) => {
	let returnMap = new Map();
	for (let [key, value] of map) {
		returnMap.set(key, value);
	}
	returnMap.set(item.id, item);
	return returnMap;
};

export const addIdObjectToNewMapAlbums = (state, item) => {
	let returnMap = new Map();
	returnMap.set(item.id, item);
	return new Map([...state.albums.entries(), ...returnMap]);
};

export const removeObjectFromNewMap = (map, id) => {
	map.delete(id);
	return new Map([...map]);
};

export const mergeIdObjectInMap = (map, idObject) => {
	let objectToMerge = map.get(idObject.id);
	objectToMerge = { ...objectToMerge,
		idObject
	};
	map.set(objectToMerge.id, { ...objectToMerge,
		...idObject
	});
	return new Map([...map]);
};


// WEBPACK FOOTER //
// ./src/common/reducer-helpers.js